import axios from '@/services/httpClient';
import { useAuthStore } from '@/stores/authStore';

async function withRetry(requestFactory, retryAttempt = false) {
  const authStore = useAuthStore();

  try {
    const response = await requestFactory(authStore);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401 && !retryAttempt) {
      await authStore.refreshAccessToken();
      return withRetry(requestFactory, true);
    }
    throw error;
  }
}

export const getCanonicalStates = async () => withRetry((authStore) =>
  axios.get('/nora_superadmin/state-registry', {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateHealthOrgs = async () => withRetry((authStore) =>
  axios.get('/nora_superadmin/state-health-orgs', {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateHealthOrg = async (uuid) => withRetry((authStore) =>
  axios.get(`/nora_superadmin/state-health-orgs/${uuid}`, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const createStateHealthOrg = async (payload) => withRetry((authStore) =>
  axios.post('/nora_superadmin/state-health-orgs', payload, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const updateStateHealthOrg = async (uuid, payload) => withRetry((authStore) =>
  axios.put(`/nora_superadmin/state-health-orgs/${uuid}`, payload, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getAssignableClinics = async (uuid) => withRetry((authStore) =>
  axios.get(`/nora_superadmin/state-health-orgs/${uuid}/clinics`, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getWatchableClinics = async (uuid) => withRetry((authStore) =>
  axios.get(`/nora_superadmin/state-health-orgs/${uuid}/watchable-clinics`, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const updateWatchableClinics = async (uuid, locationUuids) => withRetry((authStore) =>
  axios.put(`/nora_superadmin/state-health-orgs/${uuid}/watchable-clinics`, {
    location_uuids: locationUuids,
  }, {
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);
